<script setup>
import { useStore } from 'vuex';
import { onMounted, ref, defineProps, computed } from 'vue';
import ServiceExec from '@/common/utils/ServiceExec';
import { formatMaskingPhone } from '@/common/utils/module/FormattingSupport';

const store = useStore();
const props = defineProps(['data']);
const emits = defineEmits(['close']);

const { fnCallBack, targets } = props.data;

let isSearched = ref(false);
let searchText = ref('');

let userList = ref([]);
const selectedUser = ref(null);

// 검색어로 사용자 검색
const fnSearch = async () => {
  if (!searchText.value) return;

  isSearched.value = true;
  const response = await ServiceExec.get('/api/user/search', {
    searchText: searchText.value
  });
  if (response.status !== 200) return;
  userList.value = response.data;
};

const fnSelect = user => {
  // 선택된 사용자만 추출하여 콜백으로 반환
  const payload = {
    userNo: user.userNo,
    name: user.name,
    phone: user.phone,
    birthDate: user.birthDate
  };

  if (fnCallBack) fnCallBack(payload);
  emits('close');
};
</script>

<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-dim on">
      <!--'on 추가'-->
      <div class="modal-wrap">
        <div class="modal-inner whole">
          <div class="modal bg-gray">
            <header class="header">
              <div class="inner">
                <h1 class="ttl">회원 검색</h1>
                <div class="right">
                  <button class="header-btn" @click="$emit('close')"><i class="ico-close-gray90"></i></button>
                </div>
              </div>
            </header>
            <div class="head">
              <div class="search-inner">
                <label class="label search">
                  <input
                    type="text"
                    placeholder="회원 이름을 검색하세요."
                    v-model="searchText"
                    @keyup.enter="fnSearch"
                  />
                  <button class="btn-search" @click="fnSearch"><i class="ico-search"></i></button>
                </label>
              </div>
            </div>
            <div class="modal-con" v-if="isSearched && userList.length === 0">
              <div class="empty-wrap">
                <div class="empty">
                  <div>조건에 맞는 검색 결과가 없습니다.</div>
                </div>
              </div>
            </div>
            <div class="modal-con" v-else>
              <ul class="ticket-list pd0">
                <li class="card ticket" v-for="user in userList" :class="selectedUser === user ? 'on' : ''">
                  <div class="title-wrap" @click="fnSelect(user)">
                    <h3 class="title">{{ user.name }}</h3>
                    <p class="price">{{ formatMaskingPhone(user.phone) }}</p>
                  </div>
                  <div class="info-txt">
                    <p>{{ user.birthDate }}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
